import {RepositoryFilterProvider, type Repository} from '@github-ui/filter/providers'
import type {FilterQuery, AnyBlock, MutableFilterBlock, FilterConfig, ARIAFilterSuggestion} from '@github-ui/filter'
import {FilterValueType} from '@github-ui/filter'
import {singleValueFilterTypes} from '../SecurityProductsFilterBar'

export class SecurityProductsRepositoryFilterProvider extends RepositoryFilterProvider {
  #orgName: string

  constructor(orgName: string) {
    super({filterTypes: singleValueFilterTypes})

    this.#orgName = orgName
  }

  override async getSuggestions(
    filterQuery: FilterQuery,
    filterBlock: AnyBlock | MutableFilterBlock,
    config: FilterConfig,
    caretIndex?: number | null,
  ) {
    return this.processSuggestions(filterQuery, filterBlock, this.#processSuggestion.bind(this), caretIndex)
  }

  #processSuggestion(repo: Repository, query: string): ARIAFilterSuggestion {
    const {name, nameWithOwner} = repo

    return this.rankSuggestion(query, {
      type: FilterValueType.Value,
      displayName: name,
      ariaLabel: name,
      value: nameWithOwner,
      inlineDescription: false,
      icon: this.icon,
    })
  }

  override async fetchSuggestions(
    value: string,
    block: AnyBlock | MutableFilterBlock,
    filterQuery: FilterQuery,
  ): Promise<Repository[] | null> {
    const orgScopedValue = `${this.#orgName}/${value}`
    return super.fetchSuggestions(orgScopedValue, block, filterQuery)
  }
}
